// extracted by mini-css-extract-plugin
export default {"Container":"Layout_Container__uiHfa","Main":"Layout_Main__SLqmH","Users":"Layout_Users__zb+t3","Promotions":"Layout_Promotions__Ribt2"};